/**************************************************
 * Nombre:       Columna_Basica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, useMediaQuery} from "@mui/material";
import {ANCHOCOLUMNA, COLORES} from "../../Constantes";
import Tarjeta_Cabecera_Columna from "../Tarjetas/Tarjeta_Cabecera_Columna";
import Tarjeta_Lead from "../Tarjetas/Tarjeta_Lead";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Lead from "../../Dialogos/Dialogo_Lead";
import {contarWheresSuma} from "../../../Servicios/BD/Contadores/contarWheresSuma";
import {useObtenerColWhereProg} from "../../../Servicios/BD/useObtenerColWhereProg";

const Columna_Basica = ({item, index, coleccion, cargar, carga, wheresAdicionaless}) => {
    const sCell = useMediaQuery(theme => theme.breakpoints.only("xs"));
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Lead, titulo: 'Detalles Lead', realizado: cargar});
    const [wheres, setWheres] = useState([]);
    const {data, numTotal, numData, cargarMas, cargando,} = useObtenerColWhereProg({
        coleccion: 'potenciales',
        wheres: wheres,
        numero: 2,
        orden: 'fechaProximoContacto',
        direccion: 'asc'
    })
    const [valor, setValor] = useState(0);


    useEffect(() => {




        let wheres = [where('estado', '==', item), ...wheresAdicionaless]

        setWheres(wheres);

        contarWheresSuma({coleccion: coleccion, wheres: wheres, propiedad: 'valor'}).then((dox) => {
            if (dox.res) {
                setValor(dox.data);
            }
        })

    }, [item, carga, wheresAdicionaless]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                maxWidth: ANCHOCOLUMNA,
                borderRadius: 2,
            }}
        >

            <Dialogo/>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tarjeta_Cabecera_Columna item={item} color={COLORES[index]} click={abrir} numero={numTotal}
                                          valor={valor}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{mt: 2}}
            >

                {data.map((item, index) => (
                    <Grid key={'s6' + index} container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Lead item={item} click={abrir}/>
                    </Grid>
                ))}

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        loading={cargando}
                        variant="outlined"
                        fullWidth
                        onClick={() => cargarMas()}
                    >{`Cargar Proximos ${numTotal - numData}`}</Button>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Columna_Basica
